import {
  Box,
  CloseButton,
  Drawer,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { Outlet } from 'react-router';

import { Sidebar } from '../Sidebar';
import { Topbar } from '../Topbar';
import { mainCss } from './Main.styles';

/**
 * Renders the layout for authenticated pages.
 */
export const Main = () => {
  const navDrawer = useDisclosure();

  return (
    <Box className="Main" css={mainCss}>
      <Sidebar />

      <Box className="main-column">
        <Topbar onOpenMenu={navDrawer.onOpen} />
        <Box as="main">
          <Outlet />
        </Box>
      </Box>

      <Drawer.Root
        open={navDrawer.open}
        onOpenChange={({ open }) => navDrawer.setOpen(open)}
        placement="start"
        size="xs"
      >
        <Portal>
          <Drawer.Backdrop />
          <Drawer.Positioner>
            <Drawer.Content>
              <Drawer.Body padding={0}>
                <Sidebar variant="drawer" onNavigate={navDrawer.onClose} />
              </Drawer.Body>
              <Drawer.CloseTrigger asChild>
                <CloseButton size="sm" aria-label="Close navigation" />
              </Drawer.CloseTrigger>
            </Drawer.Content>
          </Drawer.Positioner>
        </Portal>
      </Drawer.Root>
    </Box>
  );
};
